import React from "react"

const Footer = () => {
    return (
        <>
            <footer className="main-footer">
                <strong>Copyright &copy; {new Date().getFullYear()} <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
                All rights reserved.
                <div class="float-right d-none d-sm-inline-block">
                    <b>Version</b> 3.2.0
                </div>
            </footer>
        </>
    )
}

export default Footer